<template>
  <div class="big-box">
    <div class="scroll-box">
      <div class="big-box-img" :style="{ 'background-image': `url(${bgUrl})` }">
        <div class="big-body">
          <img :src="tapTopUrl" alt="" class="tap-top" />
          <div class="theme" :style="{ color: customerPaperwork.titleColor }">
            {{ customerPaperwork.title }}
          </div>
          <div class="rank-record">
            <span>我的打榜记录</span>
            <span class="el-icon-arrow-right"></span>
          </div>
          <div class="content-box">
            <div class="flex-spc-x mb6">
              <div class="flexc-cen-x">
                <img
                  class="trophy"
                  src="https://cdn-image.yucrm.cn/a9902b0047424b1896c55a9029f03784.png"
                  alt=""
                />
                <span class="power-top">能量榜</span>
                <span class="rank-time ml4"
                  >剩余打榜时间：30天00时00分00秒</span
                >
              </div>
              <div class="flush">
                <img
                  class="flush-icon"
                  src="https://cdn-image.yucrm.cn/cf38c45e28804712b0c62384adf0dbb0.png"
                  alt=""
                />
                <span class="ml4">刷新</span>
              </div>
            </div>
            <div class="rank-list">
              <div
                class="rank-item"
                v-for="(item, index) in saleRankConfigs"
                :key="index"
              >
                <div class="flexc-cen-x">
                  <img
                    v-if="index ==0"
                    class="icon-url"
                    :src="customerPaperwork[`icon1Url`]"
                    alt=""
                  />
                  <img
                    v-else-if="index ==1"
                    class="icon-url"
                    :src="customerPaperwork[`icon2Url`]"
                    alt=""
                  />
                  <img
                    v-else-if="index ==2"
                    class="icon-url"
                    :src="customerPaperwork[`icon3Url`]"
                    alt=""
                  />
                  <img
                    v-if="item.picture"
                    class="rank-img ml6"
                    :src="item.picture"
                    alt=""
                  />
                  <div v-else class="rank-img-no ml6"></div>
                  <div class="flex-spc-x-c ml12">
                    <div class="rank-name">{{ item.name }}</div>
                    <div class="goods-num">
                      关联商品：{{ item.goodsList.length }}款
                    </div>
                    <div class="progress-bg fvertical">
                      <div
                        class="progress-active-bg"
                        :style="{
                          width: index === 0 ? '100%' : '50%',
                          backgroundColor: '#D4AE92',
                        }"
                      ></div>
                      <div
                        class="energy-value fcc"
                        :style="{
                          background: '#F4EADF',
                        }"
                      >
                        能量值100
                      </div>
                      <!-- customerPaperwork.energyBarColor -->
                    </div>
                  </div>
                </div>
                <div class="btn-bottom">
                  <div
                    class="btn-left"
                    v-if="ruleDTO.showOrderInfoTypes.length > 0"
                  >
                    <span
                      v-if="ruleDTO.showOrderInfoTypes.includes(0)"
                      >￥1000.00</span
                    >
                    <span class="mlr6 color-grey" v-if="ruleDTO.showOrderInfoTypes.includes(0)&&ruleDTO.showOrderInfoTypes.length>1"></span>
                    <span
                      v-if="ruleDTO.showOrderInfoTypes.includes(1)"
                      >1000笔</span
                    >
                    <span class="mlr6 color-grey" v-if="ruleDTO.showOrderInfoTypes.includes(1)&&ruleDTO.showOrderInfoTypes.includes(2)&&ruleDTO.showOrderInfoTypes.length>1"></span>
                    <span v-if="ruleDTO.showOrderInfoTypes.includes(2)"
                      >200件</span
                    >
                  </div>
                  <div
                    class="btn-rank"
                    :style="{
                      color: `${customerPaperwork.btnRankWordColor}`,
                      background: `linear-gradient(90deg, ${customerPaperwork.btnRankLeftColor} 0%, ${customerPaperwork.btnRankRightColor} 100%)`,
                    }"
                  >
                    为TA打榜
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="title" v-if="!oneShow">图为预览效果，以实际投效果为准</div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    oneShow: {
      type: Boolean,
      default: false,
    },
    ruleDTO: {
      type: Object,
      default: () => ({}),
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    saleRankConfigs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      couponLogo: "https://cdn-image.yucrm.cn/images/V24/popup_coupon.png",
      tapTopUrl:
        "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top.png",
    };
  },
  computed: {
    bgUrl() {
      return this.ruleDTO.cusTemplateJSON
        ? JSON.parse(this.ruleDTO.cusTemplateJSON).activityBgImg
        : this.backgroundImage;
    },
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 1;
  background-color: #ffffff;

  .scroll-box {
    // width: 100%;
    width: 284px;
    overflow: hidden;
    height: 560px;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    -ms-overflow-style: none;
    border-radius: 24px;
  }

  .big-box-img {
    border-radius: 24px;
    width: 284px;
    height: 755px;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .big-body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .tap-top {
      margin-top: 8px;
    }
    .theme {
      font-weight: 600;
      font-size: 22px;
      margin-top: 21px;
      text-transform: none;
    }
    .desc {
      margin: 12px auto;
      height: 10px;
      font-weight: 400;
      font-size: 11px;
      text-align: center;
      line-height: 10px;
      font-style: normal;
      text-transform: none;
    }
    .rank-record {
      margin-top: 32px;
      width: 85px;
      height: 20px;
      background: rgba(0, 0, 0, 0.15);
      border-radius: 19px 19px 19px 19px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 10px;
      color: #FFFFFF;
      line-height: 20px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
    .content-box {
      position: absolute;
      bottom: 0;
      width: 284px;
      height: 373px;
      padding: 12px 5px;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 14px 14px 0px 0px;
      border: 0px solid;
      border-image: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.5),
          rgba(255, 255, 255, 0)
        )
        0 0;
      .trophy {
        width: 13px;
        height: 13px;
      }
      .power-top {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #1a1a1a;
        line-height: 12px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      .rank-time {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 8px;
        color: #666666;
        line-height: 8px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      .flush {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 9px;
        color: #333333;
        line-height: 9px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        display: flex;
        align-items: center;
        .flush-icon {
          width: 12px;
          height: 12px;
        }
      }
      .rank-list {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 100px;
        // width: 100%;
        max-height: 330px;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 0 !important;
        }
        -ms-overflow-style: none;
        .rank-item {
          width: 100%;
          margin-top: 6px;
          height: 116px;
          padding: 12px 5px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 9px 9px 9px 9px;
          border: 0px solid rgba(255, 255, 255, 0.2);
          box-sizing: border-box;
          .icon-url {
            width: 26px;
            height: 26px;
          }
          .rank-img {
            width: 54px;
            height: 54px;
            border-radius: 6px 6px 6px 6px;
          }
          .rank-img-no {
            width: 54px;
            height: 54px;
            border-radius: 6px 6px 6px 6px;
            border: 1px solid #cccccc;
          }
          .flex-spc-x-c {
            height: 54px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;

            .rank-name {
              font-family: PingFang SC, PingFang SC;
              font-weight: 600;
              font-size: 11px;
              color: #1a1a1a;
              line-height: 11px;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }
            .goods-num {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 10px;
              color: #999999;
              line-height: 10px;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }
            .progress-bg {
              width: 154px;
              height: 6px;
              background: rgba(0, 0, 0, 0.1);
              position: relative;
              border-radius: 50px;
              .progress-active-bg {
                width: 56px;
                height: 6px;
                background: url("https://cdn-image.yucrm.cn/b225a897891a47d9882c636c9de88320.png")
                  repeat-x;
                background-size: 56px 100%;
                border-radius: 50px;
              }
              .energy-value {
                border-radius: 50px;
                font-size: 6px;
                color: #926223;
                height: 10px;
                padding: 0 2px;
                white-space: nowrap;
                margin-left: -16px;
              }
            }
          }
          .btn-bottom {
            margin-top: 12px;
            width: 100%;
            padding: 0 7px;
            height: 30px;
            background: linear-gradient(
              270deg,
              rgba(255, 255, 255, 0.1) 0%,
              rgba(255, 255, 255, 0.7) 100%
            );
            border-radius: 6px 6px 6px 6px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .btn-left {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 9px;
              color: #1a1a1a;
              line-height: 9px;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }
            .btn-rank {
              text-align: center;
              font-size: 9px;
              color: #ffffff;
              width: 54px;
              height: 20px;
              line-height: 20px;
              border-radius: 19px 19px 19px 19px;
            }
          }
        }
      }
    }
  }
  .title {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    text-align: center;
  }
  .ml4 {
    margin-left: 4px;
  }
  .ml6 {
    margin-left: 6px;
  }
  .mr6 {
    margin-right: 6px;
  }
  .mlr6 {
    margin: 0 6px;
  }
  .mb6 {
    margin-bottom: 6px;
  }
  .ml12 {
    margin-left: 12px;
  }
  .fvertical {
    display: flex;
    align-items: center;
  }
  .fcc {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .color-grey {
    display: inline-block;
    width: 1px;
    height: 7px;
    background-color: #CECECE;
    // border: 0px solid #CECECE;
  }
}
</style>
